import { BaseRepository } from './BaseRepository'

export interface DetectIntelligenceQuestion {
  uuid: string
  query: string
  answer?: string | null
  status: 'pending' | 'processing' | 'completed' | 'failed'
  error_message?: string | null
  created_at: string
  updated_at: string
}

interface AskQuestionParams {
  query: string
}

class DetectIntelligenceRepository extends BaseRepository {
  async askQuestion(detectUuid: string, params: AskQuestionParams) {
    return this.httpClient.post<{ success: boolean; item: DetectIntelligenceQuestion; error?: string }>(`/api/v2/detects/${detectUuid}/intelligence`, params)
  }

  async getQuestion(detectUuid: string, questionUuid: string) {
    return this.httpClient.get<{ success: boolean; item: DetectIntelligenceQuestion; error?: string }>(`/api/v2/detects/${detectUuid}/intelligence/${questionUuid}`)
  }
}

export const detectIntelligenceRepository = new DetectIntelligenceRepository()
